"use strict";

import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.link.js";
import jQuery from "jquery";
(function ($) {
  var $toggleBtns = $('.landing__toggle-btn');
  function applyTab(target) {
    $('.landing__pricing').each(function () {
      var data = $(this).data(target);
      var $card = $(this);
      var $img = $card.find('.landing__card-image img');
      var $price = $card.find('.landing__card-price');
      var $btn = $card.find('.landing__btn');
      if ($img.length) {
        $img.attr('src', data.image_url || '').attr('alt', data.image_alt || '');
      }
      if (data.price && data.original && data.reduc) {
        $price.html('<span class="landing__card-price-bold">' + data.price + '</span> par an au lieu de <span class="landing__card-price-bold">' + data.original + '</span><br>soit ' + data.reduc + ' de réduction').show();
      } else {
        $price.hide();
      }
      $btn.attr('href', data.link || '#');
    });
  }
  $toggleBtns.on('click', function () {
    var target = $(this).data('target');
    $toggleBtns.removeClass('landing__toggle-btn--active');
    $(this).addClass('landing__toggle-btn--active');
    applyTab(target);
  });
})(jQuery);